import api from '../../api'

const user = {
    namespaced: true,
    state: () => ({
        user: {},
        parceiro: {},
    }),
    mutations: {

        setUser(state, data) {           
            state.user = data.user;
            state.parceiro = data.parceiro;
        }

    },

    actions: {
        async getUser({ commit }) {
            const response = await api.get('auth');

            commit('setUser', response.data);

        }
    }, // promise axios

}


export default user;